module.exports = __webpack_public_path__ + "img/ring_g_l_null_1@2x.9eeeffc0.png";